export const dataList = [
    {
        id: 0,
        name: "버스정류장",
        tableName: "tb_busstop_poi",
        sub: [
            {
                id: 0,
                name: "전체"
            }
        ],
        propertyName: "code,name,update_date,admin_cd,admin_nm,geom",
        selectType: "radio"
    }, {
        id: 1,
        name: "사업체 현황",
        tableName: "vl_tb_company_poi",
        sub: [
            {
                id: 1,
                name: "농업, 임업 및 어업",
                param: "A"
            }, {
                id: 2,
                name: "광업",
                param: "B"
            }, {
                id: 3,
                name: "제조업",
                param: "C"
            }, {
                id: 4,
                name: "전기, 가스, 증기 및 공기조절 공급업",
                param: "D"
            }, {
                id: 5,
                name: "수도, 하수 및 폐기물 처리, 원료 재생업",
                param: "E"
            }, {
                id: 6,
                name: "건설업",
                operator: "=",
                param: "F"
            }, {
            //     id: 7,
            //     name: "도매 및 소매업",
            //     operator: "=",
            //     param: "G"
            // }, {
            //     id: 8,
            //     name: "운수 및 창고업",
            //     operator: "=",
            //     param: "H"
            // }, {
                id: 9,
                name: "숙박 및 음식점업",
                operator: "=",
                param: "I"
            }, {
                id: 10,
                name: "정보통신업",
                operator: "=",
                param: "J"
            }, {
            //     id: 11,
            //     name: "금융 및 보험업",
            //     operator: "=",
            //     param: "K"
            // }, {
            //     id: 12,
            //     name: "부동산업",
            //     operator: "=",
            //     param: "L"
            // }, {
                id: 13,
                name: "전문, 과학 및 기술 서비스업",
                operator: "=",
                param: "M"
            }, {
            //     id: 14,
            //     name: "사업시설 관리, 사업지원 및 임대 서비스업",
            //     operator: "=",
            //     param: "N"
            // }, {
                id: 15,
                name: "공공 행정, 국방 및 사회보장 행정",
                operator: "=",
                param: "O"
            }, {
                id: 16,
                name: "교육서비스업",
                operator: "=",
                param: "P"
            }, {
                id: 17,
                name: "보건업 및 사회복지 서비스업",
                operator: "=",
                param: "Q"
            }, {
                id: 18,
                name: "예술, 스포츠 및 여가관련 서비스업",
                operator: "=",
                param: "R"
            // }, {
            //     id: 19,
            //     name: "협회 및 단체, 수리 및 기타 개인 서비스업",
            //     operator: "=",
            //     param: "S"
            // }, {
            //     id: 20,
            //     name: "가구 내 고용활동 및 달리 분류되지 않은 자가소비 생산활동",
            //     operator: "=",
            //     param: "T"
            // }, {
            //     id: 21,
            //     name: "국제 및 외국기관",
            //     operator: "=",
            //     param: "U"
            }
        ],
        propertyName: "id,industry_code,geom",
        selectType: "checkbox"
    }, {
        id: 2,
        name: "음식점 현황",
        tableName: "vl_tb_restaurant_poi",
        sub: [
            {
                id: 0,
                name: "폐업",
                param: "3"
            }, {
                id: 1,
                name: "영업/정상",
                param: "1"
            }

        ],
        propertyName: "id,state_code,geom,permit_issue_date,termination_date",
        selectType: "radio"
    }, {
        id: 3,
        name: "공장등록 현황",
        tableName: "tb_facility_poi",
        sub: [
            {
                id:0,
                name: "전체",
            }
        ],
        propertyName: "geom",
        selectType: "radio"
    }, {
        id: 4,
        name: "폐업음식점(2020)",
        tableName: "tb_restaurant_poi_2020",
        sub: [
            {
                id: 0,
                name: "전체",
            }

        ],
        propertyName: "state_code,geom,permit_issue_date,termination_date",
        selectType: "radio"
    }, {
        id: 5,
        name: "폐업음식점(covid)",
        tableName: "tb_restaurant_poi_covid",
        sub: [
            {
                id: 0,
                name: "전체",
            }

        ],
        propertyName: "state_code,geom,permit_issue_date,termination_date",
        selectType: "radio"
    }
]